import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { A11yModule } from '@angular/cdk/a11y'
import { MatSnackBarModule } from '@angular/material/snack-bar'
import { MatCardModule } from '@angular/material/card'
import { MatButtonModule } from '@angular/material/button'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { MatButtonToggleModule } from '@angular/material/button-toggle'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatChipsModule } from '@angular/material/chips'
import { MatStepperModule } from '@angular/material/stepper'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatDialogModule } from '@angular/material/dialog'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatGridListModule } from '@angular/material/grid-list'
import { MatInputModule } from '@angular/material/input'
import { MatListModule } from '@angular/material/list'
import { MatMenuModule } from '@angular/material/menu'
import { MatPaginatorModule } from '@angular/material/paginator'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatRadioModule } from '@angular/material/radio'
import { MatSelectModule } from '@angular/material/select'
import { MatSidenavModule } from '@angular/material/sidenav'
import { MatSliderModule } from '@angular/material/slider'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { MatSortModule } from '@angular/material/sort'
import { MatTableModule } from '@angular/material/table'
import { MatTabsModule } from '@angular/material/tabs'
import { MatToolbarModule } from '@angular/material/toolbar'
import { MatTooltipModule } from '@angular/material/tooltip'

import { MatIconModule } from '@angular/material/icon'
import { SnackBarComponent } from './snack-bar/snack-bar.component'

import { DashboardComponent } from 'src/app/main/settings/dashboard/dashboard.component'
import { NgChartsModule } from 'ng2-charts'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { DateAdapter, MatNativeDateModule } from '@angular/material/core'
import { LoggingControlsComponent } from 'src/app/main/settings/dashboard/logging-controls/logging-controls.component'
import { LogViewerComponent } from 'src/app/main/settings/dashboard/log-viewer/log-viewer.component'
import { CustomDateAdapter } from 'src/app/main/shared/date/date.component'
// import { EditorModule } from '@tinymce/tinymce-angular';
import { QuillModule } from 'ngx-quill'

@NgModule({
  declarations: [
    SnackBarComponent,
    DashboardComponent,
    LoggingControlsComponent,
    LogViewerComponent,
  ],
  imports: [
    // EditorModule,
    FormsModule,
    CommonModule,
    A11yModule,
    NgChartsModule,
    ReactiveFormsModule,
    QuillModule,

    MatNativeDateModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    MatSnackBarModule,
    MatAutocompleteModule,
    MatButtonToggleModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
  ],
  exports: [
    A11yModule,
    MatSnackBarModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    MatAutocompleteModule,
    MatButtonToggleModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,

    SnackBarComponent,
    DashboardComponent,
    LoggingControlsComponent,
    LogViewerComponent
  ],
  providers: [
    { provide: DateAdapter, useClass: CustomDateAdapter }
]
})
export class NgMaterialModule { }
